// View adapter only: the Product API remains the sole persisted source.
export const inventoryProduct = product => ({
  ...product,
  images: [...new Set([product.imageUrl, ...(product.images || [])].filter(Boolean))],
  quantity: product.availableQuantity ?? (product.status === "unavailable" ? 0 : product.quantityAvailable ?? product.quantity ?? 0)
});
